// extracted by mini-css-extract-plugin
export var change = "_46-1";
export var changeList = "_46-0";
export var changePath = "_46-2";
export var diffArrow = "_46-5";
export var diffRow = "_46-3";
export var diffValue = "_46-4";
export var error = "_46-8";
export var notice = "_46-9";
export var result = "_46-6";
export var success = "_46-7";